/// <reference path="../../../../typings/index.d.ts" />
///<reference path="../short-cuts/index.d.ts"/>


module Meevo.Components.Controls {
    "use strict";

    import ClientMembershipDataService = Meevo.Components.Common.ClientMembershipDataService;
    import ClientMembershipIndicatorEnum = Meevo.Model.ClientMembershipIndicatorEnum;
    import ClientMembershipIndicatorStatusEnum = Meevo.Model.ClientMembershipIndicatorStatusEnum;

    export class MeevoTypeAhead implements angular.IDirective {
        dataService: Meevo.Components.BaseClasses.IDataService;
        restrict = 'E';
        scope = {
            model: "=ngModel",
            changed: "&?",
            template: "@",
            contentKey: "@",
            placeholderKey: "@",
            disabled: "=ngDisabled",
            criteria: "<?",
            refreshCriteria: "&?",
            view: "=",
            required: "=ngRequired",
            name: "@",
            initializeAsEmpty: "=",
            useMinimumCharacters: "<",
            minimumCharacters: "=?",
            tabIndex: "=tabIndex",
            placeholder: "@",
            asLocationId: "=?",
            businessTypeId: "=?",
            editActionEvaluator: "&?",
            addActionEvaluator: "&?",
            securityAccessKey: "@?",
            exceptionList: "=?",
            exceptionListPropertyName: "@?",
            rememberPreviousSelection: "=?",
            usageTrackNoun: "=?",
            isCustomVerb: "=?",
            preProcessData: "&?",
            emptyViewValue: "=?",
            forceNoMinimumCharacters: "=",
            gotoNextFieldOnEnter: "=?",
            employeeClientLinkDetails: "&?",
            isModal: "=?",
            defaultId: "@?",
            pageSize: "@?",
            preAddEdit: "&?",
            injectedCallback: "&?",
            callbackData: "=?",
            disableMessage: "@?",
            forModalWindow: "&?",
            hideActionButtons: '<?',
            count: '=?',
            selectedItemText: "=?",
            preserveValueOnBlur: "=?",
            sortBy: '@?',
            focusHandler: "&?",
            hideLabelContainer: '=?',
            isLoading: '=?',
            listContainerMinBottomOffset: '@?' //Space below control that should be considered when determining the positioning of the list container
        };

        template = `
<div style="position:relative;">
    <div class="meevo_input_wrapper" ng-show="::((required || contentKey) && (!hideLabelContainer))">
        <label layout="row" flex translate="{{::contentKey}}"></label>
        <div ng-class="{'ng-dirty required_red_bubble' : required && !model.displayName}"></div>
    </div>
    <div id="disable-element-blocker"></div>
    <div style="position:relative;">
        <div class="typeahead-input-wrapper" style="position: relative;width: 100%">
            <input ng-attr-tabindex="{{tabIndex}}" ng-class="{'red_border_invalid' : !selectedItemText && required}" ng-model="selectedItemText" type="text" name="{{name}}" class="meevo-typeahead-input" ng-disabled="disabled" ng-required="required" autocomplete="off" meevo-focus-highlight disable-message="{{disableMessage}}"/>
            <button class="meevo-typeahead-clearFilter" type="button" tabindex="-1" ng-disabled="disabled"></button>
        </div>
        <div class="meevo-typeahead-listContainer">
            <div class="list"></div>
            <!--REMOVED TO AVOID DUPLICATE ITEM DISPLAY-->
            <!--<div class="selectedItem meevo-typeahead-item" style="displayNone"></div>-->
            <div layout="row" class="type-ahead-buttons" flex>
                <button class="editTypeAhead" tabindex="-1" meevo-secure="{{securityAccessKeyEdit}}" ng-hide="hideButtons.editButton" type="button">Edit</button>
                <span class="seperator"></span>
                <button class="addTypeAhead" tabindex="-1" meevo-secure="{{securityAccessKeyAdd}}" ng-hide="hideButtons.addButton" type="button">Add</button>
                <span class="seperator"></span>
            </div>
        </div>
    </div>
</div>`;


        link = (scope: any, element, attr) => {
            var dataService = this.dataService;
            var securityService = this.securityService;
            var identityService = this.identityService;
            var recentService = this.recentService;
            var tempName = scope.template;
            var shortCutsService: Meevo.Components.ShortCuts.IShortCutsService = this.shortCutsService;
            var hotkeyCombos: any = {
                last: 'alt+l'
            }
            var $timeout = this.$timeout;
            var $q = this.$q;
            var vm = this;
            var template;
            var selectedDisplayTemplate;
            var endpoint;
            var stateEndPoint;
            var recentKey;
            // NOTE: Override value to true if edit action should load entity maintenance in edit mode
            // NOTE: Overriding this value shuld be done per template or refactored to be exposed for consumers to assign
            var allowEditActionInEditMode = false;

            var searchPromises: any[] = [];

            var previousSelectedItem = undefined;

            var input = $(element).find(".meevo-typeahead-input");

            if (scope.placeholderKey) {
                input.attr("placeholder", this.$translate.instant(scope.placeholderKey));
            }

            var $body = $('body');
            var wrapper = $(element).find(".typeahead-input-wrapper");
            var root = $(element);
            var container = $(root.find(".meevo-typeahead-listContainer"));
            var list = $(root.find(".list"));

            scope.minimumCharacters = scope.minimumCharacters || 2;
            scope.minimumNumberOfCharacters = (scope.useMinimumCharacters ? scope.minimumCharacters : 0);

            // Reposition handling for list container
            // It seems the case was never previously handled for this control to be in a scrollable area
            // 1. Get the first scrollable parent
            let scrollParent = $(element).scrollParent().first();
            // 2. Set up the handler with an optional debounce interval.
            // Currently set to 0ms so the reposition is smooth but can be increased if the handler ends up getting called too much.
            let debouncedHandler = _.debounce(function () {
                repositionTop();
            }, 0);
            // 3. Ensure we have a scrollParent and bind the scroll event handler
            if (!_.isEmpty(scrollParent)) {
                scrollParent.on("scroll", debouncedHandler);
            }

            if (scrollParent.hasClass('md-virtual-repeat-scroller')) {
                scrollParent.on('scroll', () => {
                    if (container.is(':visible') && !input.is(':focus')) {
                        hide();
                    }
                });
            }

            var selectedItemDisplay = $(root.find(".selectedItem"));
            var selectedIndex = -1;
            var previousIndex = 0;
            var clickHandler;
            var resizeHandler;
            var selectedItem;
            var data = [];
            var selectionChanged = false;
            var page = 0;
            var pageSize = scope.pageSize || 20;
            var hasMoreRecords = true;
            var placement;

            var deviceType = null;

            if (scope.securityAccessKey) {
                scope.securityAccessKeyEdit = scope.securityAccessKey + ":WRITE";
                scope.securityAccessKeyAdd = scope.securityAccessKey + ":CREATE";
            }

            scope.hideButtons = { addButton: scope.hideActionButtons, editButton: scope.hideActionButtons };

            configure();
            positionClearButton();

            scope.$watch("model", function (value, oldValue) {
                if (value && oldValue !== value && Boolean(scope.emptyViewValue)) {
                    input.val("");
                    input.focus();
                    selectionChanged = true;
                    list.hide();
                } else {
                    let val = !jQuery.isEmptyObject(value) ? selectedDisplayTemplate(value) : '';
                    setInputVal(val);
                    selectedItemDisplay.html(jQuery.isEmptyObject(scope.model) ? '' : template(scope.model));
                }


            });

            scope.$on('$destroy', function () {
                if (!_.isEmpty(scrollParent)) {
                    scrollParent.off("scroll", debouncedHandler);
                }
                if (clickHandler) {
                    $(document).off("click", clickHandler);
                }
                if (resizeHandler) {
                    $(window).off("resize", resizeHandler);
                }
            });

            if (scope.disableMessage != undefined && scope.disableMessage != "") {
                $timeout(function () {
                    scope.rememberPreviousSelection = true;
                    input.attr("tabindex", "-1");
                });
                $(element).find("#disable-element-blocker").width(input.width() + 4);
                $(element).find("#disable-element-blocker").height(input.height() + 4);

                $(element).find("#disable-element-blocker").css("background-color", "rgba(0,0,0,0)").css("position", "absolute");

                $(element).find("#disable-element-blocker").on("click",
                    (ev) => {
                        this.modal.alert(this.$translate.instant(scope.disableMessage));
                        return;
                    });
            }
            function positionClearButton() {
                /* Forgot why this was needed instead of just right positioning the clearFilter button.  This is no longer being called at the correct time so I'm commenting out
                hoping that its no longer needed. If it is, will have to revisit how to call at the correct time when the actual correct width of the input is known.
              $(element).find(".meevo-typeahead-clearFilter").css("left", $(element).find("input").width() - 26)*/
            }

            function setInputVal(val) {
                scope.selectedItemText = $("<textarea/>").html(val).val();
                $timeout(function () {
                    scope.$apply();
                });
            }

            function select() {
                if (selectedIndex >= 0) {
                    selectionChanged = true;
                    setSelectedItem(data[selectedIndex]);
                    hide();
                }
                if (scope.usageTrackNoun && _.isObject(selectedItem)) {
                    // only track if user selected an actual item and not clear it
                    var nounEnum: Model.NounEnum = Model.NounEnum[<string>scope.usageTrackNoun];
                    if (scope.isCustomVerb)
                        dataService.trackUsage(nounEnum, Model.VerbEnum.SelectionCriteriaChanged, null, selectedItem.id);
                    else
                        dataService.trackUsage(nounEnum, Model.VerbEnum.Selected, scope.criteria, selectedItem.id);
                }
            }

            function hide() {
                container.hide();
                $(document).off("click", clickHandler);
                $(window).off("resize", resizeHandler);
                clickHandler = null;
                resizeHandler = null;

                // Clear the list to minimize dom impact especially in case where the list is long
                list.empty();
                scope.count = 0;
                //                input.blur();

                if (selectionChanged) {
                    if (selectedItem != undefined) {
                        // Assign selecte item to model
                        scope.model = selectedItem;
                    } else if (!scope.required) {
                        scope.model = undefined;
                        if ((scope.rememberPreviousSelection || scope.rememberPreviousSelection == "true")) {
                            scope.model = previousSelectedItem;
                        }
                    } else {
                        if ((scope.rememberPreviousSelection || scope.rememberPreviousSelection == "true")) {
                            scope.model = previousSelectedItem;
                        }
                        setInputVal(jQuery.isEmptyObject(scope.model) ? '' : selectedDisplayTemplate(scope.model));
                    }
                    $timeout(() => {
                        scope.$apply();

                        // scope.changed already being called when clearing out the model in clearSelection so don't call again
                        if (scope.changed && scope.model != undefined) {
                            scope.$eval(scope.changed);
                        }
                    });
                }
                else // Just in case input text was changed without making selection, revert back to previous selected
                {
                    if ((scope.rememberPreviousSelection || scope.rememberPreviousSelection == "true")) {
                        scope.model = previousSelectedItem;
                    }

                    if (!scope.preserveValueOnBlur) {
                        setInputVal(jQuery.isEmptyObject(scope.model) ? '' : selectedDisplayTemplate(scope.model));
                    }

                }
                selectionChanged = false;
            }

            function selectNext() {
                list.children().eq(previousIndex).removeClass("meevo-typeahead-selected");
                var current = list.children().eq(selectedIndex);
                current.addClass("meevo-typeahead-selected");
                current.parent().scrollTop(0);
                var childOffsetInParent = current.position().top;
                if (childOffsetInParent + current.outerHeight() > current.parent().outerHeight()) {
                    var scrollTop = childOffsetInParent - (current.parent().outerHeight() - current.outerHeight());
                    current.parent().scrollTop(scrollTop);
                }
            }
            function processResponse(response, reset) {
                if (response.length < pageSize) {
                    hasMoreRecords = false;
                }

                if (reset) {
                    data = [];
                    list.empty();
                }

                response.forEach(function (item) {
                    var classString = 'meevo-typeahead-item';
                    if (data.length == 0) {
                        classString += " meevo-typeahead-selected";
                    }
                    if (item.applyStyle) {
                        classString += " " + item.applyStyle;
                    }
                    var indexString = " data-index=" + data.length;
                    list.append("<div class='" + classString + "' " + indexString + " style=''>" + template(item) + "</div>");
                    data.push(item);
                    selectedIndex = 0;
                });
                repositionTop();
            }

            function doFilter(reset): ng.IPromise<boolean> {
                if (reset) {
                    container.width(input.innerWidth() + 2);
                    hasMoreRecords = true;
                    selectedIndex = -1;
                    page = 0;
                    repositionTop();

                    if (searchPromises.length > 0) {
                        searchPromises.forEach((item: any) => {
                            item.defer.reject();
                        });
                        searchPromises = [];
                    }
                } else {
                    page++;
                }
                var inputValue = input.val();
                if (!inputValue.replace(/^\s+|\s+$/g, "")) {
                    input.val('');
                }

                var defer: ng.IDeferred<boolean> = $q.defer();

                if (hasMoreRecords && input.val().length >= scope.minimumNumberOfCharacters) {
                    if (scope.refreshCriteria) {
                        scope.refreshCriteria();
                        scope.$applyAsync();
                    }

                    if (Model.Guard.isNothing(scope.criteria)) {
                        // Build local default criteria if none provided
                        let criteria: any = {};
                        if (identityService.inCentralOfficeMode()) {
                            criteria.coSearchType = Meevo.Model.CoSearchType.CentralOffice;
                            criteria.coBusinessTypeId = scope.businessTypeId;
                            criteria.coSearchResultFilter = Meevo.Model.CoSearchResultsFilter.LocationOverrides;
                        }
                        // Assign local criteria
                        scope.criteria = criteria;
                    }
                    // Prepare default filtering
                    scope.criteria.filter = input.val();
                    scope.criteria.filter += scope.criteria.filter.substr(scope.criteria.filter.length - 1) == "%" ? "" : "%";
                    // Build request
                    var request = {
                        pageNumber: page,
                        itemsPerPage: pageSize,
                        criteria: scope.criteria,
                        view: scope.view,
                        asLocationId: scope.asLocationId
                    }

                    if (Model.Guard.isSomething(scope.sortBy)) {
                        request["sortBy"] = scope.sortBy;
                    }

                    if (scope.exceptionList) {
                        let serviceIds = [],
                            propertyName = scope.exceptionListPropertyName ? scope.exceptionListPropertyName : 'id';

                        for (var i = 0; i < scope.exceptionList.length; i++) {
                            if (scope.exceptionList[i] != undefined && scope.exceptionList[i][propertyName] != undefined) {
                                serviceIds.push(scope.exceptionList[i][propertyName]);
                            }
                        }
                        request.criteria.excludeIdList = serviceIds;

                    }

                    // Pos Hardware has 3 different types of hardware so we needed to pass an extra set of criteria to distiguish which hardware object to get
                    if (endpoint == "PosHardware") {
                        request["deviceType"] = deviceType;
                    }

                    if (scope.template.toLowerCase() == 'scrollablelocationselector') {
                        request['includeActive'] = true;
                        request['includeDeleted'] = false;
                        request['includeInactive'] = false;

                        scope.criteria.filter = '%' + scope.criteria.filter;
                    }

                    var promise = dataService.getListPaged(endpoint, request);
                    scope.isLoading = true;
                    searchPromises[searchPromises.length] = { promise: promise, defer: defer };
                    promise
                        .then((response: any[]) => {
                            let indexOfPromise = _.findIndex(searchPromises, (item) => item.promise === promise);
                            scope.count = response.length;

                            // Indicate if there are no results for Service Categories
                            if (scope.template.toLowerCase() === 'servicecatsub' && inputValue === '' && response.length === 0) {
                                scope.$emit('hasNoCategories', true);
                            } else {
                                scope.$emit('hasNoCategories', false);
                            }

                            if (Meevo.Model.Guard.isSomething(scope.preProcessData)) {
                                scope.preProcessData({ response: response, request: request });
                            }
                            processResponse(response, reset);

                            if (scope.defaultId) {
                                selectedIndex = _.findIndex(response, (item) => item.id == scope.defaultId);

                                $timeout(function () {
                                    selectNext();
                                    select();
                                    delete scope.defaultId;
                                    if (indexOfPromise !== -1) {
                                        searchPromises[indexOfPromise].defer.resolve(true);
                                        searchPromises.splice(indexOfPromise, 1);
                                    }
                                });
                            }
                            else {
                                if (indexOfPromise !== -1) {
                                    searchPromises[indexOfPromise].defer.resolve(true);
                                    searchPromises.splice(indexOfPromise, 1);
                                }
                            }
                        })
                        .catch(() => {
                            if (searchPromises.length === 0) {
                                return;
                            }
                            let indexOfPromise = _.findIndex(searchPromises, (item) => item.promise === promise);
                            if (indexOfPromise === -1) {
                                return;
                            }
                            if (indexOfPromise < (searchPromises.length - 1)) {
                                searchPromises[indexOfPromise].defer.reject();
                                searchPromises.splice(indexOfPromise, 1);
                                return;
                            }
                            searchPromises[indexOfPromise].defer.resolve(false);
                            searchPromises.splice(indexOfPromise, 1);
                        })
                        .finally(() => {
                            scope.isLoading = false;
                        })
                }
                else {
                    defer.resolve(true);
                }

                return defer.promise;
            }

            function doFilterInput() {
                timeout = null;
                return doFilter(true);
            }

            function handleRecent() {
                if (!_.isEmpty(recentKey)) {
                    recentService.addRecent(selectedItem, recentKey, true);
                }
            }

            function setSelectedItem(val) {
                selectedItem = val;
                if (!jQuery.isEmptyObject(selectedItem)) {
                    selectedItemDisplay.show();
                    list.hide();
                    handleRecent();
                    previousSelectedItem = selectedItem;
                } else {
                    selectedItemDisplay.hide();
                    list.show();
                }
            }

            function repositionTop() {
                var top;
                if (placement == "top") {
                    top = wrapper.position().top - container.outerHeight();
                } else {
                    top = wrapper.position().top + input.outerHeight();
                }

                if (scope.forModalWindow) { // needed for reposition in modal windows
                    $body = $('md-dialog') || $body;
                }

                // STEVE O : This is a check to see if the list container is extending beneath the page, if so, it will reposition the typeahead on the top of the input field.
                if (($body.height() - (input.offset().top + input.outerHeight() + container.outerHeight() +
                    +(scope.listContainerMinBottomOffset || 0))) < 0) {
                    container.css("top", "-" + (container.height()) + "px");
                } else {
                    container.css("top", top + "px");
                }
            }

            var timeout;
            function delayFilter(func, wait) {
                clearTimeout(timeout);
                timeout = setTimeout(func, wait);
            };

            function configure() {
                placement = attr.placement != undefined ? attr.placement.toLowerCase() : "bottom";
                var defaultTemplate = '{{#if shortcut}}{{shortcut}}: {{displayName}}{{else}}{{displayName}}{{/if}}';
                if (scope.template == undefined) {
                    throw "Template not specificied";
                }
                var securityKey;
                selectedDisplayTemplate = null;
                stateEndPoint = null;
                Handlebars.registerHelper('translateEnum', function (key) {
                    var translated = vm.$translate.instant("ENUM_LABEL_"+key);
                    return new Handlebars.SafeString(translated)
                });
                switch (scope.template.toLowerCase()) {
                    case "alertcat":
                        endpoint = "alertCat";
                        template = Handlebars.compile("{{alertCategory}}");
                        break;
                    case "alertuser":
                        endpoint = "alertUser";
                        template = Handlebars.compile("{{employeeCode}}");
                        break;
                    case "client":
                        scope.useMinimumCharacters = true;
                        scope.minimumCharacters = 4;
                        scope.minimumNumberOfCharacters = (scope.useMinimumCharacters ? scope.minimumCharacters : 0);
                        securityKey = Meevo.Components.Common.SecurityKeys.DATA_CLIENT_TAB_MAIN;
                        endpoint = "Membership/ClientMembership";
                        stateEndPoint = "client";
                        recentKey = Meevo.Components.Common.Constants.RECENT_KEY_CLIENT;
                        selectedDisplayTemplate = Handlebars.compile("{{displayName}}{{#if primaryPhoneNumber}} - {{format primaryPhoneNumber type='phoneFormat' countryCode=primaryPhoneNumberCountryCode}}{{/if}}");
                        template = Handlebars.compile(
                            "<div class=\"meevo-typeahead-parent\">\
                                <div class=\"meevo-typeahead-client-info\">\
                                    <div class=\"meevo-typeahead-client-name\">\
                                        {{ displayName }}\
                                    </div>\
                                    <div class=\"meevo-typeahead-client-phone-number\">\
                                        {{#if primaryPhoneNumber}}{{format primaryPhoneNumber type='phoneFormat' countryCode=primaryPhoneNumberCountryCode}}{{/if}}\
                                    </div>\
                                </div>\
                                <div class=\"meevo-typeahead-indicators\">\
                                    {{#unless hasLocalProfile}}\
                                        <img class=\"lg_icon\" src=\"assets/images/icons/global.svg\"/>\
                                    {{/unless}}\
                                    {{#if hasActivePaymentPlan}}\
                                        <img class=\"lg_icon\" src=\"assets/images/icons/pmtplan_current.svg\"/>\
                                    {{/if}}\
                                    {{#if (showMembershipIcon clientMembershipIndicatorStatus clientMembershipIndicator)}}\
                                        <img class=\"lg_icon\" src=\"{{membershipIcon clientMembershipIndicator}}\"/>\
                                    {{/if}}\
                                </div>\
                            </div>"
                        );
                        break;
                    case "clientclienttype":
                        securityKey = Meevo.Components.Common.SecurityKeys.DATA_CLIENTCLIENTTYPE_TAB_MAIN;
                        endpoint = "clientClientType";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "clientnonfamily":
                        endpoint = "client";
                        template = Handlebars.compile("{{displayName}}{{#if primaryPhoneNumber}} - {{format primaryPhoneNumber type='phoneFormat' countryCode=primaryPhoneNumberCountryCode}}{{/if}}");
                        break;
                    case "employee":
                        endpoint = "employee";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "employeeoverrides":
                        endpoint = "employee/serviceStepOverrides";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "payroll/employee":
                        endpoint = "Report/PayrollEmployee";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "referral":
                        endpoint = "referraltype";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "service":
                    case "clientservice":
                        endpoint = "service";
                        template = Handlebars.compile(defaultTemplate);
                        break;
                    case "servicecatsub":
                        endpoint = "servicecatsub";
                        template = Handlebars.compile("{{catDisplayName}}:{{displayName}}");
                        break;
                    case "servicecategory":
                        endpoint = "servicecategory";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "giftcardtype":
                        endpoint = "giftcardtype";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "visitnotetype":
                        endpoint = "visitnotetype";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "employeetemplate":
                        endpoint = "employeetemplate";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "employeecategory":
                        endpoint = "employeecategory";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "locationcity":
                        endpoint = "location";
                        template = Handlebars.compile("{{city}}");
                        break;
                    case "locationstate":
                        endpoint = "location";
                        template = Handlebars.compile("{{state}}");
                        break;
                    case "appointmentcategory":
                        endpoint = "AppointmentCategory";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "securityrole":
                        endpoint = "securityrole";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "smartcenter":
                        endpoint = "smartcenter";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "location":
                        endpoint = "location";
                        template = Handlebars.compile("{{storeName}}");
                        break;
                    case "scrollablelocationselector":
                        endpoint = "changelocation";
                        template = Handlebars.compile("{{storeName}}");
                        break;
                    case "cancellationtype":
                        endpoint = "CancellationType";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "userlocations":
                        endpoint = "changelocation";
                        template = Handlebars.compile("{{storeName}}");
                        break;
                    case "blocktype":
                        endpoint = "blocktype";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "resource":
                        endpoint = "resource";
                        template = Handlebars.compile(defaultTemplate);
                        break;
                    case "resourceunit":
                        endpoint = "resourceunit";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "businesstype":
                        endpoint = "businesstype";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "userbusinesstype":
                        endpoint = "userbusinesstype";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "resourcecategory":
                        endpoint = "resourceCategory";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "locationgroup":
                        endpoint = "locationgroup";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "pricegroup":
                        endpoint = "MarketPricing/Group";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "marketpricing":
                        endpoint = "marketPricing";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "workactivity":
                        endpoint = "workactivity";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "holidaytypes":
                        endpoint = "tenant/holidaytypes";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "equipment":
                        endpoint = "equipment";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "employeepromo":
                        endpoint = "employeepromo";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "manufacturer":
                        endpoint = "manufacturer";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "meevomessengeremployee":
                        endpoint = "meevomessenger/employee";
                        stateEndPoint = "employee";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "meevomessengerclient":
                        endpoint = "meevomessenger/client";
                        stateEndPoint = "client";
                        scope.useMinimumCharacters = true;
                        scope.minimumCharacters = 4;
                        scope.minimumNumberOfCharacters = (scope.useMinimumCharacters ? scope.minimumCharacters : 0);
                        securityKey = Meevo.Components.Common.SecurityKeys.DATA_CLIENT_TAB_MAIN;
                        recentKey = Meevo.Components.Common.Constants.RECENT_KEY_CLIENT;
                        Handlebars.registerHelper('isMobilePhone', function (phoneType, phoneNumber) {
                            return phoneType === Meevo.Model.PhoneTypeEnum.Mobile && !phoneNumber.startsWith('X'); //2-nd check to hide masked numbers
                        });
                        selectedDisplayTemplate = Handlebars.compile("{{displayName}}{{#if primaryPhoneNumber}}{{#if (isMobilePhone primaryPhoneNumberType primaryPhoneNumber)}} - {{format primaryPhoneNumber type='phoneFormat' countryCode=primaryPhoneNumberCountryCode}}{{/if}}{{/if}}");
                        template = Handlebars.compile(
                            "<div class=\"meevo-typeahead-parent\">\
                                <div class=\"meevo-typeahead-client-info\">\
                                    <div class=\"meevo-typeahead-client-name\">\
                                        {{ displayName }}\
                                    </div>\
                                    <div class=\"meevo-typeahead-client-phone-number\">\
                                        {{#if primaryPhoneNumber}}{{#if (isMobilePhone primaryPhoneNumberType primaryPhoneNumber)}}{{format primaryPhoneNumber type='phoneFormat' countryCode=primaryPhoneNumberCountryCode}}{{/if}}{{/if}}\
                                    </div>\
                                </div>\
                            </div>"
                        );
                        break;
                    case "distributor":
                        endpoint = "distributor";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "productcategory":
                        endpoint = "productcategory";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "productsubcategory":
                        endpoint = "productsubcategory";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "productvariant":
                        endpoint = "ProductVariant";
                        template = Handlebars.compile("{{#if sku}}{{sku}} : {{/if}}{{displayName}}{{#if variantDisplayName}} - {{variantDisplayName}}{{/if}}{{#if barCode}} : {{barCode}}{{/if}}");
                        break;
                    case "productvariantcse":
                        endpoint = "ProductVariant";
                        template = Handlebars.compile("{{#if sku}}{{sku}} : {{/if}}{{displayName}}{{#if variantDisplayName}} - {{variantDisplayName}}{{/if}}");
                        break;
                    case "inventorycountproductvariant":
                        endpoint = "InventoryCount/ProductVariant";
                        template = Handlebars.compile("{{sku}} : {{productName}}{{#if displayName}} - {{displayName}}{{/if}} : {{barCode}}");
                        break;
                    case "inventoryreturnproductvariant":
                        endpoint = "InventoryReturn/ProductVariant";
                        template = Handlebars.compile("{{sku}} : {{productName}}{{#if displayName}} - {{displayName}}{{/if}} : {{barCode}}");
                        break;
                    case "purchaseorderproduct":
                        endpoint = "PurchaseOrder/Product";
                        template = Handlebars.compile("{{sku}} : {{displayName}}{{#if variantDisplayName}} - {{variantDisplayName}}{{/if}} : {{barCode}} {{#if isRetailShopSupply}} - {{enumDisplayName}}{{/if}}");
                        break;
                    case "stocklevelproduct":
                        endpoint = "Inventory/StockLevel/Product";
                        template = Handlebars.compile("{{sku}} : {{displayName}}{{#if variantDisplayName}} - {{variantDisplayName}}{{/if}} : {{barCode}} {{#if isRetailShopSupply}} - {{enumDisplayName}}{{/if}}");
                        break;
                    case "inventorytransferproduct":
                        endpoint = "InventoryTransfer/Product";
                        template = Handlebars.compile("{{sku}} : {{productDisplayName}}{{#if displayName}} - {{displayName}}{{/if}} : {{barCode}} {{#if isRetailShopSupply}} - {{enumDisplayName}}{{/if}}");
                        break;

                    case "employeesupplyproductvariant":
                        endpoint = "InventoryCount/ProductVariant";
                        template = Handlebars.compile("{{sku}} : {{productName}}{{#if displayName}} - {{displayName}}{{/if}} : {{barCode}} ({{translateEnum productInventoryType}})");
                        break;
                    case "notificationtemplate":
                        endpoint = "template";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "securitymanagermoduleselection":
                        endpoint = "securitymanagermoduleselection";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "userdefinedcontrol":
                        endpoint = "CustomData/Control";
                        template = Handlebars.compile("{{controlName}}");
                        break;
                    case "userdefinedtab":
                        endpoint = "CustomData/TabView";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "services":
                        endpoint = "CustomData/Service";
                        template = Handlebars.compile(defaultTemplate);
                        break;
                    case "drawerusers":
                        endpoint = "EmployeeUser";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "creditcard":
                        endpoint = "PosHardware";
                        template = Handlebars.compile("{{displayName}}");
                        deviceType = Meevo.Model.DeviceTypeEnum.CreditCard;
                        break;
                    case "printer":
                        endpoint = "PosHardware";
                        template = Handlebars.compile("{{displayName}}");
                        deviceType = Meevo.Model.DeviceTypeEnum.Printer;
                        break;
                    case "posstation":
                        endpoint = "PosHardware";
                        template = Handlebars.compile("{{displayName}}");
                        deviceType = Meevo.Model.DeviceTypeEnum.PosStation;
                        break;
                    case "packagetype":
                        endpoint = "PackageType";
                        template = Handlebars.compile("{{displayName }}");
                        break;
                    case "packagetypeservice":
                        endpoint = "packagetypeservice";
                        template = Handlebars.compile(defaultTemplate);
                        break;
                    case "packagetypeproduct":
                        endpoint = "PackageTypeProduct";
                        template = Handlebars.compile("{{#if sku}}{{sku}} : {{/if}}{{displayName}}{{#if variantDisplayName}} - {{variantDisplayName}}{{/if}}{{#if barCode}} : {{barCode}}{{/if}}");
                        break;
                    case "packagetypeproductunit":
                        endpoint = "ProductVariant";
                        template = Handlebars.compile("{{displayName}}{{#if variantDisplayName}} - {{variantDisplayName}}{{/if}}");
                        break;
                    case "packagetypeformemberships":
                        endpoint = "packagetype";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "swapgroupservice":
                        endpoint = "swapgroupservice";
                        template = Handlebars.compile(defaultTemplate);
                        break;
                    case "floorlocation":
                        endpoint = "floorLocation";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "membershiptype":
                        endpoint = "membershiptype";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "merchantaccounts":
                        endpoint = "Tenant/BusinessInfo/MerchantAccounts";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "securityroleoffsite":
                        endpoint = "securityroleoffsite";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "securityroleinternal":
                        endpoint = "securityroleinternal";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "users":
                        endpoint = "securityRole/AvailableUsers";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "memberbenefittemplate":
                        endpoint = "memberBenefitTemplate";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "membership":
                        endpoint = "membership";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "membershipshortcut":
                        endpoint = "membership";
                        template = Handlebars.compile("{{shortcut}}: {{displayName}}");
                        break;
                    case "drawermerchantaccount":
                        endpoint = "merchantAccount";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "productbundles":
                        endpoint = "productBundles/ProductVariant";
                        template = Handlebars.compile("{{sku}} : {{displayName}} : {{barCode}}");
                        break;
                    case "imagegallerycategory":
                        endpoint = "imagegallerycategory";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "learningtracks":
                        endpoint = "MeevoStore/LearningTrack";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "fees":
                        endpoint = "DiscountFee";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "egiftlocation":
                        endpoint = "eGift/Location";
                        template = Handlebars.compile("{{storeName}}");
                        break;
                    case "discount":
                        endpoint = "discount";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "usagereason":
                        endpoint = "usageReason";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "yieldmanagerstrategy":
                        endpoint = "YieldManagement/Strategy";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "yieldmanagementprogram":
                        endpoint = "YieldManagement/Program";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "locationgroupuserrole":
                        endpoint = "locationgrouproles";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    case "paymenttype":
                        endpoint = "paymentType";
                        template = Handlebars.compile("{{displayName}}");
                        break;
                    default:
                        throw "Modal type a ahead configuration exception: Modal type could not be found";
                }
                if (!selectedDisplayTemplate) {
                    selectedDisplayTemplate = template;
                }
                if (!stateEndPoint) {
                    stateEndPoint = endpoint;
                }

                if (!scope.hideActionButtons) {
                    let editButton = $(container.find(".editTypeAhead"));
                    scope.hideButtons.editButton = false;
                    editButton.on("click", function () {
                        if (!isEmptyObject(scope.model)) {
                            if (scope.usageTrackNoun) {
                                dataService.trackUsage(scope.usageTrackNoun, Model.VerbEnum.Updated, null, scope.model.id);
                            }
                            if (securityKey) {
                                var writeKey = securityKey + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE;
                                securityService.checkSecurityKey(writeKey).then(result => {
                                    let actionState = result == Meevo.Model.SecurityAccessEnum.Grant && allowEditActionInEditMode ?
                                        Model.MaintenanceFormState.Editing : Model.MaintenanceFormState.Readonly;

                                    goToState(stateEndPoint, actionState, scope.model.id, Meevo.Model.TypeaheadMode.Edit);
                                });
                            } else {
                                let actionState = allowEditActionInEditMode ? Model.MaintenanceFormState.Editing : Model.MaintenanceFormState.Readonly
                                goToState(stateEndPoint, actionState, scope.model.id, Meevo.Model.TypeaheadMode.Edit);
                            }
                        }
                    });

                    let addButton = $(container.find(".addTypeAhead"));
                    scope.hideButtons.addButton = false;
                    addButton.on("click", function () {
                        if (scope.usageTrackNoun) {
                            dataService.trackUsage(scope.usageTrackNoun, Model.VerbEnum.Created, null);
                        }
                        goToState(stateEndPoint, Meevo.Model.MaintenanceFormState.Adding, undefined, Meevo.Model.TypeaheadMode.Add);
                    });
                }
            }

            function goToState(stateName, actionState, id: any = undefined, typeaheadMode: Meevo.Model.TypeaheadMode) {
                var employeeData = null;
                if (Model.Guard.isSomething(scope.employeeClientLinkDetails))
                    employeeData = scope.employeeClientLinkDetails();
                var stateParams = {
                    callback: scope.injectedCallback || callback,
                    callbackController: scope.injectedCallback ? true : false,
                    callbackState: vm.$state.current.name,
                    callbackData: scope.callbackData,
                    targetState: Meevo.Model.MaintenanceFormVisualState.Detail,
                    actionState: actionState,
                    id: id,
                    initialEditSection: "SECTION_CLIENT_MAIN",
                    employeeClientLinkDetails: employeeData,
                    typeaheadMode: typeaheadMode
                };

                vm.$rootScope.$broadcast("gotoState", {
                    stateName: stateName,
                    stateParams: stateParams
                });
                if (scope.preAddEdit) {
                    scope.$eval(scope.preAddEdit);
                }
            }

            function callback(model, callbackContext) {
                if (!Model.Guard.isSomething(model)) {
                    return;
                }

                let isAdd = callbackContext.typeaheadMode === Model.TypeaheadMode.Add;
                let isEdit = callbackContext.typeaheadMode === Model.TypeaheadMode.Edit &&
                    scope.model &&
                    scope.model.id === model.id;

                if (isAdd || isEdit) {
                    scope.model = model;
                    setInputVal(selectedDisplayTemplate(model));
                    if (scope.changed) {
                        $timeout(() => {
                            scope.$eval(scope.changed);
                        });
                    }
                }
            }

            function isEmptyObject(obj) {
                return !obj || jQuery.isEmptyObject(obj);
            }
            function clearSelection() {
                input.val("");
                input.focus();
                selectionChanged = true;

                setSelectedItem(undefined);
                list.empty();
                // Need to clear out model at this point b/c if you immediately click a button somewhere else on the screen, that click handler fires prior before where the model was previously
                // being cleared
                scope.model = undefined;
                $timeout(() => {
                    container.width(input.width());
                    scope.$apply();
                    if (scope.changed) {
                        scope.$eval(scope.changed);
                        showOrHideActions();
                    }
                });
                doFilter(true);
            }

             function registerHotkeys() {
                if (tempName == "client") {
                    shortCutsService.add('TA_LAST_CLIENT', (event, key) => {
                        var lastClient = recentService.getRecent(Meevo.Components.Common.Constants.RECENT_KEY_CLIENT);
                        if (!_.isEmpty(lastClient)) {
                            setSelectedItem(lastClient);
                            selectionChanged = true;
                            hide();
                        }
                    }, { scope });
                }
            }

            const destroyHotKeys = () => {
                if (tempName === 'client') {
                shortCutsService.del('TA_LAST_CLIENT');
            }
            };

            function showOrHideActions() {
                if (!scope.hideActionButtons && container.is(":visible")) {
                    // Determine whether to display element

                    var displayAddButton = true;
                    var displayEditButton = true;

                    if (Meevo.Model.Guard.isSomething(scope.editActionEvaluator)) {
                        displayEditButton = scope.editActionEvaluator();
                    }
                    if (Meevo.Model.Guard.isSomething(scope.addActionEvaluator)) {
                        displayAddButton = scope.addActionEvaluator();
                    }

                    scope.hideButtons["addButton"] = !displayAddButton;
                    scope.hideButtons["editButton"] = !displayEditButton;
                } else {
                    scope.hideButtons["addButton"] = true;
                    scope.hideButtons["editButton"] = true;
                }
            }

            input.on("input", function () {
                setSelectedItem(undefined);
                if (input.val().length >= scope.minimumNumberOfCharacters) {
                    delayFilter(doFilterInput, 400);
                } else {
                    list.empty();
                }
            });

            list.on("click", "div", function () {
                selectedIndex = $(this).data("index");
                selectNext();
                select();
            });

            input.on("focus", () => {
                if (scope.disableMessage != undefined && scope.disableMessage != "") {
                    this.modal.alert(this.$translate.instant(scope.disableMessage));
                    return;
                }
                if (Meevo.Model.Guard.isSomething(scope.focusHandler)) {
                    scope.focusHandler().then(() => scope.focusWorker()).catch(() => {
                        input.blur();
                    });
                }
                else {
                    scope.focusWorker();
                }
            });

            scope.focusWorker = () => {
                if (container.is(":hidden")) {
                    repositionTop();
                    selectionChanged = false;
                    setSelectedItem(scope.model);

                    container.show();
                    showOrHideActions();
                    list.show();
                    clickHandler = function (e) {
                        if (!root.is(e.target) // if the target of the click isn't the container...
                            && root.has(e.target).length === 0
                            && !container.is(e.target) && container.has(e.target).length == 0) // ... nor a descendant of the container
                        {
                            hide();
                        }
                    }
                    resizeHandler = function () {
                        var top = /*input.offset().top +*/ input.outerHeight();//I'm not sure why this was in here before but it seems to be the issue for all of the list positioning problems
                        container.css("top", top + "px");
                    }
                    $(document).on("click", clickHandler);
                    $(window).on("resize", resizeHandler);
                    doFilter(true);
                }
                registerHotkeys();
            }

            input.on('focusout', () => {
                destroyHotKeys();
            });


            input.on("keydown", function (e) {
                previousIndex = selectedIndex;
                switch (e.keyCode) {
                    case 40: // down arrow
                        if (list.children().length > 0 && previousIndex != list.children().length - 1) {
                            selectedIndex++;
                            // Get next page
                            if (selectedIndex == list.children().length - 1) {
                                doFilter(false);
                            }
                            selectNext();
                        }
                        break;
                    case 38: // up arrow
                        if (list.children().length > 0 && previousIndex != 0) {
                            selectedIndex--;
                            selectNext();
                        }

                        break;
                    case 13: // return
                        e.preventDefault();
                        var onEnter = () => {
                            select();
                            if (!jQuery.isEmptyObject(selectedItem) && Meevo.Model.Guard.isSomething(scope.gotoNextFieldOnEnter) && Boolean(scope.gotoNextFieldOnEnter)) {
                                var inputsOnPage = input.scrollParent().find("[tabIndex]"), ndx, len = inputsOnPage.length;
                                var found = false;
                                if (scope.tabIndex > 0) {
                                    // if this control has a tabIndex defined, look for the next control with (tabIndex + 1) value
                                    for (ndx = 0; ndx < len; ndx++) {
                                        if (inputsOnPage[ndx].tabIndex == scope.tabIndex + 1) {
                                            hide();
                                            inputsOnPage[ndx].focus();
                                            found = true;
                                            break;
                                        }
                                    }
                                }
                                if (!found) {
                                    inputsOnPage = $("[tabIndex]");
                                    len = inputsOnPage.length;
                                    // if this control does not have a tabIndex, just look for it in the document and put focus on the next control
                                    ndx = _.findIndex(inputsOnPage, (ctl) => { return ctl == input[0] });
                                    if (ndx >= 0 && ++ndx < len) {
                                        hide();
                                        inputsOnPage[ndx].focus();
                                    }
                                }
                            }
                        };

                        // When pressing "Enter", we need to know whether the user finished typing or not yet; This is based on the timeout variable.
                        // We need to do this to support using barcode scanners into a typeahead. Barcode scanner will put in the value with the Enter
                        // key along with it in a rather quick fashion.  When the enter is clicked, it will select the first item on the list eventhough
                        // the dataService has not filtered the list with the scanned barcode value yet.  This is also true for fast typers.
                        if (timeout != null) {
                            doFilterInput().then(() => onEnter());
                        }
                        else {
                            onEnter();
                        }
                        break;
                    case 9: // tab
                        hide();
                        break;
                }
            });

            input.on("keyup", function (e) {
                if (input.val() == "") {
                    scope.model = undefined;
                }
            });

            $(root.find(".meevo-typeahead-clearFilter")).on("click", () => {
                if (scope.disableMessage != undefined && scope.disableMessage != "") {
                    this.modal.alert(this.$translate.instant(scope.disableMessage));
                    return;
                }
                clearSelection();
            });

            list.on('scroll', function () {
                // Get next page
                // Math.ceil rounds the number up an integer, the scrollTop is throwing decimals depending on screen size, i.e apptBook Editor > services
                if (this.scrollHeight - Math.ceil(this.scrollTop) <= this.clientHeight) {
                    doFilter(false);
                }
            });

            if (scope.initializeAsEmpty) {
                // if modal, setTimeout is needed to ensure element has loaded before setting focus
                if (scope.isModal) {
                    window.setTimeout(clearSelection, 750);
                } else {
                    clearSelection();
                }
            }

            var focusHint;
            attr.$observe('focusHint', (hint) => {
                focusHint = hint;
            });
            scope.$on(Meevo.Components.Common.Messages.TYPEAHEAD_FOCUS, (message, payload) => {
                if (payload === focusHint) {
                    setTimeout(() => {
                        input.focus();
                    }, 1);
                }
            });

            if (scope.defaultId) {
                doFilter(true);
            }
        }

        /** 
        * Sets up reposition handling for when a parent container scrolls.
        */
        setUpScrollHandling(element) {

        }

        constructor(dataService: Meevo.Components.BaseClasses.IDataService,
            private $rootScope: any,
            private $state: any,
            private $timeout: any,
            private recentService: Meevo.Components.Common.RecentService,
            private shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            private $translate:ng.translate.ITranslateService,
            private identityService,
            private securityService: Meevo.Components.Common.ISecurityService,
            private modal: Meevo.Components.Modal.IModalService,
            private $q: ng.IQService,
            private clientMembershipDataService: ClientMembershipDataService,
        ) {
            this.dataService = dataService;
            this.identityService = identityService;

            Handlebars.registerHelper('membershipIcon', (clientMembershipIndicator) =>  {
                return clientMembershipDataService
                    .getClientMembershipIndicatorEnumIcon(clientMembershipIndicator)
            });
            Handlebars.registerHelper('showMembershipIcon', function (clientMembershipIndicatorStatus, clientMembershipIndicator) {
                return clientMembershipIndicatorStatus
                    && angular.isDefined(clientMembershipIndicator)
                    && !(
                        clientMembershipIndicatorStatus === ClientMembershipIndicatorStatusEnum.Expired
                        && clientMembershipIndicator === ClientMembershipIndicatorEnum.GreenStar
                    );
            });
        }

        static factory(): angular.IDirectiveFactory {
            let directive = (dataService: Meevo.Components.BaseClasses.IDataService,
                $rootScope: any,
                $state: any,
                $timeout: any,
                recentService: Meevo.Components.Common.RecentService,
                shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
                $translate,
                identityService,
                securityService: Meevo.Components.Common.ISecurityService,
                modal: Meevo.Components.Modal.IModalService,
                $q: any,
                clientMembershipDataService: ClientMembershipDataService,
            ) => {
                return new MeevoTypeAhead(dataService,
                    $rootScope,
                    $state,
                    $timeout,
                    recentService,
                    shortCutsService,
                    $translate,
                    identityService,
                    securityService,
                    modal,
                    $q,
                    clientMembershipDataService,
                );
            };

            directive.$inject = [
                "meevo.components.common.DataService",
                "$rootScope",
                "$state",
                "$timeout",
                "meevo.components.common.RecentService",
                "meevo.components.short-cuts.ShortCutsService",
                "$translate",
                "meevo.components.common.IdentityService",
                "meevo.components.common.SecurityService",
                "meevo.components.modal.ModalService",
                "$q",
                "meevo.components.common.ClientMembershipDataService",
            ];
            return directive;
        }
    }

    angular.module('meevo.components.controls').directive("meevoTypeAhead", MeevoTypeAhead.factory());
}
